module.exports = __webpack_public_path__ + "static/media/IconTemplates_-16.f839d014.svg";